<p-editor [style]="{'height':'320px'}" [formControl]="formControl">
    <ng-template pTemplate="header">
        <span class="ql-formats">
            <button type="button" class="ql-bold" aria-label="Bold"></button>
            <button type="button" class="ql-italic" aria-label="Italic"></button>
            <button type="button" class="ql-underline" aria-label="Underline"></button>
        </span>
        <span class="ql-formats"><button value="ordered" aria-label="Ordered List" type="button" class="ql-list"><svg
                    viewBox="0 0 18 18">
                    <line class="ql-stroke" x1="7" x2="15" y1="4" y2="4"></line>
                    <line class="ql-stroke" x1="7" x2="15" y1="9" y2="9"></line>
                    <line class="ql-stroke" x1="7" x2="15" y1="14" y2="14"></line>
                    <line class="ql-stroke ql-thin" x1="2.5" x2="4.5" y1="5.5" y2="5.5"></line>
                    <path class="ql-fill"
                        d="M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z">
                    </path>
                    <path class="ql-stroke ql-thin"
                        d="M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156"></path>
                    <path class="ql-stroke ql-thin"
                        d="M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109">
                    </path>
                </svg></button><button value="bullet" aria-label="Unordered List" type="button" class="ql-list"><svg
                    viewBox="0 0 18 18">
                    <line class="ql-stroke" x1="6" x2="15" y1="4" y2="4"></line>
                    <line class="ql-stroke" x1="6" x2="15" y1="9" y2="9"></line>
                    <line class="ql-stroke" x1="6" x2="15" y1="14" y2="14"></line>
                    <line class="ql-stroke" x1="3" x2="3" y1="4" y2="4"></line>
                    <line class="ql-stroke" x1="3" x2="3" y1="9" y2="9"></line>
                    <line class="ql-stroke" x1="3" x2="3" y1="14" y2="14"></line>
                </svg></button><span class="ql-align ql-picker ql-icon-picker"><span class="ql-picker-label"
                    tabindex="0" role="button" aria-expanded="false" aria-controls="ql-picker-options-4"><svg
                        viewBox="0 0 18 18">
                        <line class="ql-stroke" x1="3" x2="15" y1="9" y2="9"></line>
                        <line class="ql-stroke" x1="3" x2="13" y1="14" y2="14"></line>
                        <line class="ql-stroke" x1="3" x2="9" y1="4" y2="4"></line>
                    </svg></span><span class="ql-picker-options" aria-hidden="true" tabindex="-1"
                    id="ql-picker-options-4"><span tabindex="0" role="button" class="ql-picker-item"><svg
                            viewBox="0 0 18 18">
                            <line class="ql-stroke" x1="3" x2="15" y1="9" y2="9"></line>
                            <line class="ql-stroke" x1="3" x2="13" y1="14" y2="14"></line>
                            <line class="ql-stroke" x1="3" x2="9" y1="4" y2="4"></line>
                        </svg></span><span tabindex="0" role="button" class="ql-picker-item" data-value="center"><svg
                            viewBox="0 0 18 18">
                            <line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"></line>
                            <line class="ql-stroke" x1="14" x2="4" y1="14" y2="14"></line>
                            <line class="ql-stroke" x1="12" x2="6" y1="4" y2="4"></line>
                        </svg></span><span tabindex="0" role="button" class="ql-picker-item" data-value="right"><svg
                            viewBox="0 0 18 18">
                            <line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"></line>
                            <line class="ql-stroke" x1="15" x2="5" y1="14" y2="14"></line>
                            <line class="ql-stroke" x1="15" x2="9" y1="4" y2="4"></line>
                        </svg></span><span tabindex="0" role="button" class="ql-picker-item" data-value="justify"><svg
                            viewBox="0 0 18 18">
                            <line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"></line>
                            <line class="ql-stroke" x1="15" x2="3" y1="14" y2="14"></line>
                            <line class="ql-stroke" x1="15" x2="3" y1="4" y2="4"></line>
                        </svg></span></span></span><select class="ql-align" style="display: none;">
                <option selected=""></option>
                <option value="center"></option>
                <option value="right"></option>
                <option value="justify"></option>
            </select></span>
    </ng-template>
</p-editor>